import React, {useState} from "react";
import {FilledInput, FormControl, IconButton, InputAdornment, InputLabel,} from "@mui/material";
import {Visibility, VisibilityOff} from "@mui/icons-material";

export default function DHPasswordField({id, label, width, value, disabled, onChange, onKeyDown}) {

    const [showPassword, setShowPassword] = useState(false);

    return <FormControl sx={{ width: width }} variant="filled">
        <InputLabel htmlFor={id}>{label}</InputLabel>
        <FilledInput
            id={id}
            value={value}
            disabled={disabled}
            onChange={(event) => onChange(event.target.value)}
            type={showPassword ? 'text' : 'password'}
            onKeyDown={(e) => {
                if( onKeyDown !== undefined) {
                    onKeyDown(e);
                }
            }}
            endAdornment={
                <InputAdornment position="end">
                    <IconButton
                        aria-label={
                            showPassword ? 'hide the password' : 'display the password'
                        }
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                    >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                </InputAdornment>
            }
        />
    </FormControl>

}